export const bettingPhases = {
    early: "early",
    board: "board",
    starting: "starting",
    ignore: "ignore"
}

export const providers = {
    betmakers: "betmakers",
    pa: "PA"
}

export const categories = {
    horses: "HR",
    dogs: "DG"
}

export const scheduleVariables = {
    meetingPageSize: 6
}
